import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaStopFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "2", width: "14", height: "14", rx: "2.75", ry: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconMediaStopFill18.js.map